import axiosInstance from '../../../core/services/axiosConfig';
import { apis } from '../../../core/services/params';
import React, { useState, useEffect } from 'react';
import { Spin, message } from 'antd';
import { useNavigate } from 'react-router-dom';

// @@ AI-COMMENT: Props for the Sahara call details smart opener
interface SaharaCallDetailsModalProps {
    visible: boolean;
    phone?: string;
    onClose: () => void;
}

// @@ AI-COMMENT: Fetches most recent Sahara Voice AI call for a phone then navigates to SaharaCallDetailsPage
const SaharaCallDetailsModal: React.FC<SaharaCallDetailsModalProps> = ({ visible, phone, onClose }) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // @@ AI-COMMENT: On open, fetch Sahara calls by caller_phone and navigate to the most recent UCID
    useEffect(() => {
        if (!visible || !phone) return;
        setLoading(true);
        axiosInstance.post(`${apis.OZONETEL_VOICE_AI_AGENT}?page=1&per_page=5`, {
            filters: { caller_phone: phone }
        }).then(res => {
            const calls: any[] = res.data?.data || [];
            if (calls.length > 0) {
                navigate(`/crm/ozonetel-call-track/${calls[0].ucid}`);
            } else {
                message.info('No Sahara Voice AI calls found for this phone number.');
            }
            onClose();
        }).catch(() => {
            message.error('Failed to fetch Sahara call records.');
            onClose();
        }).finally(() => {
            setLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible, phone]);

    // @@ AI-COMMENT: Show a brief fullscreen spinner while resolving the UCID
    if (visible && loading) {
        return (
            <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
                <div className="bg-white rounded-xl p-6 flex flex-col items-center gap-3 shadow-xl">
                    <Spin size="large" />
                    <p className="text-sm text-gray-500">Fetching Voice AI call details...</p>
                </div>
            </div>
        );
    }

    return null;
};

export default SaharaCallDetailsModal;
